import React, { useState } from "react";
import { ABtn, AResult } from "./arcadeUi";

// Classic stapu layout: 1 / 2 / 3 / 4-5 / 6 / 7-8
const LAYOUT = [[1], [2], [3], [4, 5], [6], [7, 8]];

export default function Hopscotch() {
  const [stone, setStone] = useState(() => 2 + Math.floor(Math.random() * 6)); // 2..7 (skip this)
  const [seq, setSeq] = useState(() => buildSeq(2 + Math.floor(Math.random() * 6)));
  const [idx, setIdx] = useState(0);
  const [status, setStatus] = useState("play"); // play | win | fault

  function buildSeq(sk) { return [1, 2, 3, 4, 5, 6, 7, 8].filter((n) => n !== sk); }

  const tap = (n) => {
    if (status !== "play") return;
    if (n === stone) { setStatus("fault"); return; } // stepped on the stone square
    if (n === seq[idx]) {
      const ni = idx + 1;
      setIdx(ni);
      if (ni >= seq.length) setStatus("win");
    } else {
      setStatus("fault");
    }
  };

  const reset = () => {
    const sk = 2 + Math.floor(Math.random() * 6);
    setStone(sk); setSeq(buildSeq(sk)); setIdx(0); setStatus("play");
  };

  const cellState = (n) => {
    if (n === stone) return "stone";
    if (seq.indexOf(n) < idx) return "done";
    if (n === seq[idx]) return "next";
    return "todo";
  };

  return (
    <div className="w-full text-center">
      <p className="mb-3 text-sm text-kirana-brown/70">Hop the squares in order 1→8, but <b>skip the square with the stone</b> 🪨. Tap the glowing square next.</p>
      <div className="mx-auto flex w-full max-w-[220px] flex-col-reverse gap-1.5" data-testid="stapu-grid">
        {LAYOUT.map((row, ri) => (
          <div key={ri} className="flex justify-center gap-1.5">
            {row.map((n) => {
              const s = cellState(n);
              return (
                <button key={n} data-testid={`stapu-cell-${n}`} onClick={() => tap(n)}
                  className={`flex h-14 flex-1 items-center justify-center rounded-md border-[3px] border-kirana-brown font-signboard text-xl font-bold transition-colors ${
                    s === "stone" ? "bg-kirana-brown text-kirana-cream" : s === "done" ? "bg-kirana-green/70 text-white" : s === "next" ? "zone-glow bg-kirana-gold text-kirana-brown" : "bg-kirana-cream text-kirana-brown/70"
                  }`}>
                  {s === "stone" ? "🪨" : n}
                </button>
              );
            })}
          </div>
        ))}
      </div>
      {status === "win" && (
        <>
          <AResult testId="stapu-result" win text="Perfect round! 🎉" />
          <div className="mt-3 flex justify-center"><ABtn data-testid="stapu-again" onClick={reset} tone="green">Next Round</ABtn></div>
        </>
      )}
      {status === "fault" && (
        <>
          <AResult testId="stapu-result" win={false} text="Foul! You stepped wrong 😅" />
          <div className="mt-3 flex justify-center"><ABtn data-testid="stapu-again" onClick={reset} tone="green">Try Again</ABtn></div>
        </>
      )}
    </div>
  );
}
